import get from 'lodash/get';

import ga from '@ott/google-analytics';
import { lang, langCode } from '@ott/l10n';
import { parseDateStringUTC, stringifyDateUTC } from '@ott/utility-date';

import getUserInfoOnce from '../getUserInfoOnce';
import { getOptions } from '../options';
import getCityInfo from './getCityInfo';

import Cookie from 'js-cookie';

function createIntentMediaScript() {
  require('./integrationScript');
}

const referrersWhiteList = ['yandex_direct', 'google_adwords'];

async function process(page, props, sendOpenExitUnit) {
  const country = lang.split('-')[1] || lang;
  const currency = {
    ru: 'RUB',
    'ru-kz': 'KZT',
    kz: 'KZT',
  };

  const vid = Cookie.get('vid');
  const source = Cookie.get('referrer');
  const channel = 'meta';

  const {
    date,
    returnDate,
    adults = 0,
    children = 0,
    infants = 0,
    itemsCount,
    toCode,
    metaTo,
    totalAmount,
    promoAmount,
    orderId,
    auth,
    to = {},
  } = props;

  const formatedStartDate = date && stringifyDateUTC(parseDateStringUTC(date));
  const formatedEndDate = returnDate && stringifyDateUTC(parseDateStringUTC(returnDate));

  const cityInfo = await getCityInfo(toCode || metaTo || (to && to.id));

  const params = {
    site_name: 'ONETWOTRIP_RU',
    page_id: page,
    site_country: country,
    site_language: langCode,
    site_currency: currency[lang],

    user_member_id: vid,
    visitor_id: Cookie.get('sid'),
    referrer_source: source,
    referrer_channel: channel,
    active_member_profile: get(auth, 'data.auth', false) ? 'Y' : 'N',

    travel_date_start: formatedStartDate,
    travel_date_end: formatedEndDate,
    adults: +(adults || 0),
    children: +(children || 0),
    infants: +(infants || 0),
    number_of_opaque_listings: itemsCount,

    hotel_city: cityInfo.city,
    hotel_country: cityInfo.country,
  };

  params.travelers = params.adults + params.children + params.infants || 1;

  if (page === 'train.confirmation') {
    params.total_conversion_value = totalAmount;
    params.order_id = orderId;
    params.promo_code = promoAmount ? 'Y' : 'N';
  }

  if (!window.IntentMediaProperties) {
    window.IntentMediaBindings = {
      segmentation_group_updated: {
        callback(data) {
          ga('send', 'IntentScoreAction', {
            dimension19: `${data && data.group}`,
          });
        },
      },
    };

    window.IntentMediaProperties = params;
    createIntentMediaScript();
  } else if (sendOpenExitUnit) {
    window.IntentMediaProperties = params;
    if (window.IntentMedia && window.IntentMedia.trigger) {
      window.IntentMedia.trigger('open_exit_unit');
    }
  } else {
    window.IntentMediaProperties = params;
    const trigger = window.IntentMedia && window.IntentMedia.trigger;
    if (trigger) {
      trigger('refresh');
    }
  }
}

export default function intentMedia(page, props = {}, sendOpenExitUnit) {
  return (dispatch, getState) => {
    const referrer = Cookie.get('referrer');
    if (
      typeof window === 'undefined' ||
      !referrersWhiteList.includes(referrer) ||
      !getOptions().sendIntentMediaStats
    ) {
      return;
    }

    dispatch(getUserInfoOnce()).finally(() => {
      const {
        common: { auth },
      } = getState();

      process(page, { ...props, auth }, sendOpenExitUnit);
    });
  };
}
